// // @ts-nocheck
import { formatMoney } from '@theme/money';
import {BundleVariantUpdateEvent, ThemeEvents, UpsellUpdateEvent, BundleCombinationChangeEvent} from "@theme/events";

document.addEventListener('click', async (event) => {
    if(!event.target.closest('[data-bandle-product]')) return

    event.preventDefault()

    const parentElement = event.target.closest('[data-bandle-product]')    

    const variantPicker = parentElement.closest('.shopify-section, dialog')?.querySelector('variant-picker')

    if(!variantPicker) {
      window.location.href = parentElement.getAttribute('href')
      return
    }

    const productData = await (await fetch(`${parentElement.getAttribute('href')}.js`)).json()
    
    const matchedVariant = productData?.variants.find(variant => {
        return JSON.stringify(variant.options) == JSON.stringify(variantPicker.selectedOptionsNames)
    })

    let url = parentElement.getAttribute('href')

    if(matchedVariant) url += `?variant=${matchedVariant.id}`

    window.location.href = url
    
})

const handlersByType = {
  'upsell-checkbox': onUpsellCheckboxChange
};

document.addEventListener('change', handleChange);

function handleChange(event) {
  const target = event.target.closest('[data-type]');

  if (!target) return;

  const type = target.dataset.type;
  const handler = handlersByType[type];

  if (handler)
    handler(event, target);
}


function syncUpsell(label) {
  const main = label.querySelector('.upsell__input, .upsell__input-swatch');
  if (!main) return;

  const opts = label.querySelectorAll('.upsell-option__input');

  label.classList.toggle('checked', main.checked);

  if (!opts.length || main.hasAttribute('data-price')) return;

  if (!main.checked) {
    opts.forEach(o => { o.checked = false; });
    return;
  }

  if (!Array.from(opts).some(o => o.checked) && opts[0]) {
    opts[0].checked = true;
  }
}


function onUpsellCheckboxChange(event) {
  const label = event.target.closest('.upsell-checkbox');
  if (!label) return;

  const main = label.querySelector('.upsell__input, .upsell__input-swatch');
  const isVariant = event.target.classList.contains('upsell-option__input');

  if (isVariant && main && !main.checked) {
    main.checked = true;
  }

  const inputNode = label.querySelector('[type="checkbox"]')

  inputNode && (inputNode.value = event.target.value)

  event.target.dispatchEvent(new UpsellUpdateEvent());

  syncUpsell(label);
}

class ProductPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.section = this.closest('.shopify-section');

    if(!this.section) return;

    this.section.addEventListener(ThemeEvents.upsellUpdate, () =>{
        this.updatePrice()
    });
  }


  get upsellsPrice(){
    let upsellPrice = 0
    
    this.section.querySelectorAll('.upsell-checkbox input[data-upsell-checkbox]').forEach(input => {
      if (input.checked) {        
        if (input.hasAttribute('data-price')) {
          const addPrice = parseInt(input.dataset.price, 10) || 0;
          upsellPrice += addPrice;
        } else {
          const optionPrice = parseInt(input.closest('.upsell-checkbox').querySelector('.upsell-option__input:checked')?.dataset.price || 0, 10) || 0;
          upsellPrice += optionPrice;
        }
      }
    })

    return upsellPrice;
  }

  updatePrice() {
    const priceWrapper = this.section.querySelector('#final-price');

    priceWrapper && (priceWrapper.textContent = formatMoney(+this.dataset.price + this.upsellsPrice))
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}